import { toast } from 'sonner';

let socket = null;
let reconnectTimer = null;
let pingTimer = null;
let reconnectDelay = 1000;
let audioCtx = null;

const getToken = () =>
  localStorage.getItem('fortis_token') || localStorage.getItem('token');

const playBeep = () => {
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === 'suspended') audioCtx.resume();
    const o = audioCtx.createOscillator();
    const g = audioCtx.createGain();
    o.connect(g);
    g.connect(audioCtx.destination);
    o.type = 'sine';
    o.frequency.setValueAtTime(880, audioCtx.currentTime);
    o.frequency.setValueAtTime(660, audioCtx.currentTime + 0.12);
    g.gain.setValueAtTime(0.0001, audioCtx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.18, audioCtx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.4);
    o.start();
    o.stop(audioCtx.currentTime + 0.42);
  } catch (e) {
    /* sessiz */
  }
};

const handleMessage = (data) => {
  if (!data || !data.type) return;
  if (data.type === 'notification') {
    const n = data.notification || {};
    toast(n.title || 'Yeni bildirim', { description: n.message || '' });
    window.dispatchEvent(new CustomEvent('fortis:new-notification', { detail: n }));
    window.dispatchEvent(new Event('unread-counts-updated'));
    window.dispatchEvent(new CustomEvent('fortis:refresh', { detail: { source: 'notification' } }));
  } else if (data.type === 'data_change') {
    window.dispatchEvent(new CustomEvent('fortis:refresh', { detail: { path: data.path, method: data.method } }));
    window.dispatchEvent(new Event('unread-counts-updated'));
  }
};

const scheduleReconnect = () => {
  if (!getToken()) return;
  clearTimeout(reconnectTimer);
  reconnectTimer = setTimeout(connectRealtime, reconnectDelay);
  reconnectDelay = Math.min(reconnectDelay * 2, 15000);
};

export const connectRealtime = () => {
  const token = getToken();
  if (!token) return;
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return;

  const base = process.env.REACT_APP_BACKEND_URL || '';
  const wsUrl = `${base.replace(/^http/, 'ws')}/api/ws?token=${encodeURIComponent(token)}`;

  try {
    socket = new WebSocket(wsUrl);
  } catch (e) {
    scheduleReconnect();
    return;
  }

  socket.onopen = () => {
    reconnectDelay = 1000;
    clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      try {
        if (socket && socket.readyState === WebSocket.OPEN) socket.send('ping');
      } catch (e) {
        /* sessiz */
      }
    }, 25000);
  };
  socket.onmessage = (ev) => {
    try {
      handleMessage(JSON.parse(ev.data));
    } catch (e) {
      /* sessiz */
    }
  };
  socket.onclose = () => {
    clearInterval(pingTimer);
    socket = null;
    scheduleReconnect();
  };
  socket.onerror = () => {
    try {
      socket.close();
    } catch (e) {
      /* sessiz */
    }
  };
};

export const disconnectRealtime = () => {
  clearTimeout(reconnectTimer);
  clearInterval(pingTimer);
  reconnectDelay = 1000;
  if (socket) {
    try {
      socket.close();
    } catch (e) {
      /* sessiz */
    }
    socket = null;
  }
};
